import { RESET_ALL_ACCOUNT_STATE_DEPEN } from "../actions/commonActions";
import {
  FETCH_DOCUMENTS_FAILURE,
  FETCH_DOCUMENTS_REQUEST,
  FETCH_DOCUMENTS_SUCCESS,
} from "../actions/documentActions";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const documentReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DOCUMENTS_REQUEST:
      return { ...state, loading: true, payload: action.payload };
    case FETCH_DOCUMENTS_SUCCESS: {
      const map = new Map();

      for (const item of action.payload) {
        if (!map.has(item.filingVersionId)) {
          map.set(item.filingVersionId, item);
        }
      }

      return {
        ...state,
        loading: false,
        data: [...map.values()],
      };
    }
    // case FETCH_DOCUMENTS_SUCCESS:
    //   return { ...state, loading: false, data: action.payload };
    case FETCH_DOCUMENTS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case RESET_ALL_ACCOUNT_STATE_DEPEN: {
      return { ...state, loading: false, data: [] };
    }
    default:
      return state;
  }
};

export default documentReducer;
